module.exports = __webpack_public_path__ + "media/images/cbjj/academy_registration_informations/competitors_draw-452e4304546b700f320850014294cee1.svg";